import { borderRadius, shadows } from '../KestrixDesignSystem.jsx'
import { colorTokens } from '../tokens/colors.ts'

/** The collapsed compass sits at the right. The hint appears to its left. */
export const COLLAPSED_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1
} as const

export const COLLAPSED_BUTTON_SX = {
  display: 'inline-flex',
  p: 0,
  border: 'none',
  borderRadius: '50%',
  backgroundColor: 'transparent',
  boxShadow: shadows.consistent,
  cursor: 'pointer',
  '&:hover': { boxShadow: shadows.lg },
  '&:focus-visible': {
    outline: `2px solid ${colorTokens.semantic.brand.primary}`,
    outlineOffset: 2
  }
} as const

export const EXPANDED_CARD_SX = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 1,
  p: 1,
  borderRadius: borderRadius.md,
  backgroundColor: colorTokens.semantic.brand.base.white,
  border: `1px solid ${colorTokens.surface.border.subtle}`,
  boxShadow: shadows.consistent
} as const

const BUTTON_STATES = colorTokens.buttonStates.secondary

export const COLLAPSE_BUTTON_SX = {
  position: 'absolute',
  top: 6,
  right: 6,
  zIndex: 1,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  p: 0,
  border: 'none',
  borderRadius: borderRadius.base,
  backgroundColor: 'transparent',
  color: BUTTON_STATES.default.icon,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: BUTTON_STATES.hover.surface,
    color: BUTTON_STATES.hover.icon
  },
  '&:focus-visible': {
    outline: `2px solid ${colorTokens.semantic.brand.primary}`,
    outlineOffset: 1
  }
} as const
